import { ChoiceOption } from 'commons/types/DTO/commons'

const selectMapper = (licenseItem: { name: string; id: number; entityUID: string }): ChoiceOption => ({
  label: licenseItem.name,
  value: licenseItem.id || licenseItem.entityUID
})

export default selectMapper
